module.exports = __webpack_public_path__ + "img/fa-brands-400.804f83c4.svg";